import React from 'react';
import ReactDom from 'react-dom';
import pt from 'prop-types';
import Icon from 'components/icon';
import Button from 'components/button';

import { isSectionOrBlockPath } from 'components/storefront/editor/utils/easyblocks';
import { postStorefrontOverlayPageItemEllipsis } from 'components/storefront/editor/utils/post-message';

const REMOVE_BUTTON_SELECTOR = "button[title='Remove component']";

export default class EasyblocksItemActions extends React.PureComponent {
  static propTypes = {
    focusedField: pt.string,
    loading: pt.bool,
  };

  onClickItemActions = (event) => {
    const { focusedField } = this.props;
    const domRect = event.target.getBoundingClientRect();

    postStorefrontOverlayPageItemEllipsis(domRect, focusedField, {
      actions: [['hide', 'duplicate'], ['delete']],
      offsetX: 20,
    });
  };

  render() {
    const { loading, focusedField } = this.props;

    if (!isSectionOrBlockPath(focusedField)) {
      return null;
    }

    const removeButton = document.querySelector(REMOVE_BUTTON_SELECTOR);
    const container = removeButton?.parentElement;

    if (!container) {
      return null;
    }

    // Render a custom item actions button in the default "Remove component" button container
    return ReactDom.createPortal(
      <Button
        className="storefront-editor--easyblocks--item-actions"
        onClick={this.onClickItemActions}
        disabled={loading}
      >
        <Icon fa="ellipsis-h" />
      </Button>,
      container,
    );
  }
}
